var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav-component'),_c('order-status'),_c('order-type'),_c('payment-method')],1)}
var staticRenderFns = []

export { render, staticRenderFns }